import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedCompsModule } from '../shared/shared-comps.module';
import { UserSubscriptionsComponent } from './user-subscriptions/user-subscriptions.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { DialogService } from '../shared/CustomDialog/DialogService';
import { WaterMonitoringModule } from '../water-monitoring/water-monitoring.module';

@NgModule({
	declarations: [UserSubscriptionsComponent],
	imports: [
		CommonModule,
		SharedCompsModule,
		FormsModule,
		ReactiveFormsModule, 
		OverlayModule,
		WaterMonitoringModule
	],
	exports : [UserSubscriptionsComponent]	
})
export class SubscriptionsModule { }
